export type LanguageCode = typeof LanguageCodes[number];
export const LanguageCodes = [ 'da', 'en' ] as const;

export type LocalizedText = {
    value:string,
    lang?:LanguageCode
}

export function buildTranslator(languageCode:LanguageCode)
{
    return (texts:LocalizedText[]):string =>
    {
        const localization = texts.find(t=>t.lang === languageCode);
        if(localization)
        {
            return localization.value;
        }

        const defaultLocalization = texts.find(t=>t.lang === undefined);
        if(defaultLocalization)
        {
            return defaultLocalization.value;
        }

        throw new Error('No translation found and no default translation defined');
    }
}